import {
  RECEPTION_FEATURES_LEVEL_ALLOWED,
  RECEPTION_FEATURES_LEVEL_FORBIDDEN,
  RECEPTION_FEATURES_LEVEL_WITH_CAUTION,
} from '@/shared/constants/drugs.constants';

import type { ReceptionFeatureLevel } from '../../types';

export const RECEPTION_FEATURES_LEVELS: ReceptionFeatureLevel[] = [
  RECEPTION_FEATURES_LEVEL_ALLOWED,
  RECEPTION_FEATURES_LEVEL_FORBIDDEN,
  RECEPTION_FEATURES_LEVEL_WITH_CAUTION,
];

export const RECEPTION_FEATURES_LEVELS_LABELS: Record<ReceptionFeatureLevel, string> = {
  allowed: 'Разрешено',
  forbidden: 'Запрещено',
  with_caution: 'С осторожностью',
};
